import { BaseDto } from '../base.dto';
import { IsBoolean, IsDefined, IsInt, IsNotEmpty, IsOptional, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '../../constants';

export class BankingCompRefundCategoryDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantGroupId: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 45)
  @Matches(validationPatterns.nameValidation)
  name: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsOptional()
  @IsInt()
  nominalReportingId?: number;
}
